import React from 'react'
import CardEditV2 from './CardEditV2'
const MainCardEdit = () => {

   
    
        return (
            
            <section className='grid'>
               
              <div className="contentfront">
              
              {/* <div className='justify top-page'> */}
                
                <CardEditV2 />
              {/* </div> */}
            
        
              {/* Render the userCards instead of dummyCards */}
             
              </div>
            </section>
          );
    
    }
    
  

export default MainCardEdit